<template>
  <section class="common-layout">
    <header class="rsk-header rsk-header--admin">
      <div class="rsk-header__left-block">
        <!-- <a href="javascript:void(0);" style="background-image: url('/static/image/logo.png');" class="rsk-header__logo"></a> -->
        <img src="../../assets/logo.png" alt="サイバックスUniv." style="width:166px;height:32px" />
      </div>
    </header>
    <nav class="rsk-global-nav rsk-global-nav--user" style="height: 2px"></nav>
    <section class="main" style="min-width: 9.8rem; min-height: 58.8rem;">
      <br/>
      <br/>
      <br/>
      <div>
        <div
          style="width: 385px; margin-left: 41.6%; margin-bottom: 20px"
          type="flex"
          v-show="model.errorMsg"
        >
          <span class="err__msg" style="height: 60px">
            <img
              style="width: 25px; height: 25px"
              src="../../assets/icon_err.gif"
              alt="."
            />&nbsp;
            <b v-dompurify-html="model.errorMsg" style="color: red; font-size: 13px"></b>
          </span>
        </div>
      </div>
      <br/>
      <br/>
      <br/>
    </section>
  </section>
</template>
<style lang="scss" src="../login/css/login.scss"/>
<script>
import { ref, onMounted, inject } from 'vue'
import { getUsrMenu } from '../login/cont/login_cont.js'
import UAParser from 'ua-parser-js'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { setToken } from '../../utils/CookieUtils'
import { dateFtt } from "@/utils/common";
export default {
  setup () {
    const service = inject("service");
    const ua = new UAParser();
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const model = ref({errorMsg: ''})
    var authId;
    var authFlag;
    var smtFlag;
    var encodeParam;
    var userAgent = ua.getUA();
    
    onMounted(() => {
      if (route.query.authId) {
        authId = route.query.authId;
	    }
      if (route.query.authFlag) {
        authFlag = route.query.authFlag;
	    }
      if (route.query.smtFlag) {
        smtFlag = route.query.smtFlag;
	    }
      if (route.query.taskParm) {
        encodeParam = route.query.taskParm;
	    }
      const formData = {
        authId: authId,
        authFlag: authFlag,
        smtFlag: smtFlag,
        encodeParam: encodeParam,
        userAgent: userAgent,
      }
      service.external.pageShow(formData).then(res => {
        if(res.token != null) {
          model.value.errorMsg = null;
          setToken(res.token)
          getUsrMenu().then(async result => {
            if (res.loginInfo.useFlag && res.loginInfo.useFlag === 1) {
              localStorage.useFlag = true
            } else {
              localStorage.useFlag = false
            }
            if (result.data.displayFlg1) {
              store.commit('changeDisplayFlg1')
              localStorage.displayFlg1 = true
            } else {
              localStorage.displayFlg1 = false
            }
            if (result.data.displayFlg2) {
              store.commit('changeDisplayFlg2')
              localStorage.displayFlg2 = true
            } else {
              localStorage.displayFlg2 = false
            }
            if (result.data.displayFlg5) {
              store.commit('changeDisplayFlg5')
              localStorage.displayFlg5 = true
            } else {
              localStorage.displayFlg5 = false
            }
            if (result.data.agencyId) {
              store.commit('changeAgencyId')
              localStorage.agencyId = true
            } else {
              localStorage.agencyId = false
            }
            await store.dispatch("permMenu", router)
            localStorage.setItem('getCopyRightFlg',res.getCopyRightFlg);
            localStorage.setItem('getComIdFlag',res.getComIdFlag);
            localStorage.setItem('traShowFlag',res.traShowFlag);
            localStorage.setItem('traSelfShowFlag',res.traSelfShowFlag);
            localStorage.setItem('isDispatchAgencyFlag',res.isDispatchAgencyFlag)
            localStorage.setItem('InfoFlg',res.InfoFlg)
            localStorage.setItem('logoUrl',res.logoUrl)
            localStorage.setItem('logoutBtnFlag',res.loginInfo.logoutFlg);
            localStorage.setItem('comNm', res.loginInfo.comNm)
            /**パラメータ.タスク分類（taskType）およびパラメータ.引数（taskParm）の値に基づき、**/

            //・パラメータ.タスク分類が「1:ボックス」の場合
            if (res.taskType === '1') {
              //パラメータ.引数から「ボックスID」を取得し、パラメータとしてボックス詳細画面へ遷移する。
              router.push({ name: 'lesDetail',params:{lessonId:res.taskParam}})
            }

            //・パラメータ.タスク分類が「2:eLearning」の場合
            if (res.taskType === '2') {
              //パラメータ.引数文字列を「-」で分割し、以下の6項目を取得する。
              const params = res.taskParam.split('-');
              var lessonIdReal;
              const [elearningId, lessonId, applicationDtm, termOutside, nonScormType, newContentFlg] = params;

              //新コンテンツが「1：チェックする」場合、
              if (newContentFlg === '1') {
                // elearningIdと登録日をパラメータとして、新コンテンツ学習画面へ遷移する。
                let applicationDtmStr = dateFtt('auto', applicationDtm, 'en').replace(new RegExp('/', 'gm'), '')
                const params = {
                  elearningId: elearningId,
                  applicationDtm: applicationDtmStr
                }
                setTimeout(() => {
                  sessionStorage.setItem('sharedData', JSON.stringify(params))
                  window.open('/lessonContent', '_self')
                  
                })
              } else if (nonScormType === '1') {
                
                //非SCORM形式（目次無し）が「1：フリーランス動画」場合、

                //elearningId、ボックスIDと登録日をパラメータとして、フリーランス動画再生画面へ遷移する。
                let applicationDtmStr =  dateFtt("auto",applicationDtm,"en").replace(new RegExp("/","gm"),"")
                let route = router.resolve({ name: 'popElgmov',query:{elearningId:elearningId,lessonId:lessonId,applicationDtm:applicationDtmStr}})
                window.open(route.href, '_self', 'top=50,left=200,width=800,height=600')
              } else {
                lessonIdReal = lessonId;
                //他の場合、
                if (lessonIdReal == '' || lessonIdReal == null) {
                    lessonIdReal = '9999999999';
                }
              
                let cd = '';
                let iv = '';
                let sso_url = '';
                let applicationDtmStr =  dateFtt("auto",applicationDtm,"en").replace(new RegExp("/","gm"),"")
                const data = {
                  'elearningId': elearningId,
                  'lessonId': lessonIdReal,
                  'applicationDtm': applicationDtmStr,
                  'termOutside': termOutside
                }
                service.sso.setSso(data).then((resSso) => {
                  let model = resSso;
                  if (model.statusNum == '0') {
                          sso_url = model.elearningURL;
                          cd = model.cd;
                          iv = model.iv;
                          let form = document.createElement('form')
                          form.action = sso_url;
                          form.method = 'POST'
                          form.target = '_self'
                          document.body.append(form);

                          let cdhidden = document.createElement('input')
                          cdhidden.type = 'hidden'
                          cdhidden.name = 'cd'
                          cdhidden.value = cd
                          form.appendChild(cdhidden);

                          let ivhidden = document.createElement('input')
                          ivhidden.type = 'hidden'
                          ivhidden.name = 'iv'
                          ivhidden.value = iv;
                          form.appendChild(ivhidden);

                          form.submit();
                          form.remove();
                  } else {
                      alert(model.statusMessage);
                  }
                  }).catch((error) => {
                  console.log(error);
                  alert('セッションタイムアウトしました。ログインし直してください。');
                  router.push({ path: '/login' })
                });
              }
            }
            //・パラメータ.タスク分類が「3:テスト」の場合
            if (res.taskType === '3') {
              
              //パラメータ.引数文字列を「-」で分割し、以下の3項目を取得する。
              const params = res.taskParam.split('-');
              const [testId, lessonId, answerFlg] = params;

              //確認済フラグが「false」場合、
              if (answerFlg === 'false') {
                model.value.errorMsg = "実際問題数は不足なので、問題作成後、再度お試しください。";
                return;
              } else {
                //他の場合、
                //テストIDとボックスIDをパラメータとして、テスト解答画面へ遷移する。
                let id = testId + "-" + lessonId;
                router.push({
                  name: 'testAnswer',
                  params: {
                      id : id,
                      fromUrl: 'usr_top_children'
                  }
                })
              }
            }

            //・パラメータ.タスク分類が「4:アンケート」の場合
            if (res.taskType === '4') {
              //パラメータ.引数文字列を「-」で分割し、以下の2項目を取得する。
              const params = res.taskParam.split('-');
              const [anketoId, lessonId] = params;
              //アンケートIDとボックスIDをパラメータとして、アンケート回答画面へ遷移する
              let id = anketoId + "-" + lessonId;
              router.push({
                name: 'anketoAnswer',
                params: {
                    id : id,
                    fromUrl: 'usr_top_children'
                }
              })
            }
            //・パラメータ.タスク分類が「5:レポート」の場合
            if (res.taskType === '5') {
              //パラメータ.引数文字列を「-」で分割し、以下の2項目を取得する。
              const params = res.taskParam.split('-');
              const [reportId, lessonId] = params;
              //レポートIDとボックスIDをパラメータとして、レポート回答画面へ遷移する
              let id = reportId + "-" + lessonId;
              router.push({
                name: 'reportSend',
                params: {
                    id : id,
                    fromUrl: 'usr_top_children'
                }
              })
            }

          })
        }
      }).catch(err => {
        if(err.code == 500) {
          model.value.errorMsg = err.message;
        }
        return err
      })
    })

    function setloginToSession(loginInf) {
      var information = {
        comId: loginInf.comId,
        loginComId: loginInf.loginComId,
        usrId: loginInf.usrId,
        userProjectShowFlag: loginInf.userProjectShowFlag,
        loginAgencyId: loginInf.loginAgencyId,
        fromRismonFlag: loginInf.fromRismonFlag,
        pwdChgDiv: loginInf.pwdChgDiv,
        jccFlag: loginInf.jccFlag,
        loginId: loginInf.loginId
      }
      localStorage.setItem('login',JSON.stringify(information));
    }
    return {
      model
    }
  }
}
</script>